export const minimumPasswordLength = 8;
export const minimumRequiredValidations = 3;
